import * as React from "react";
function SvgComponent(props) {
  return <svg {...props} width={35} height={35} fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx={17.5} cy={17.5} r={17.5} fill="#000" fillOpacity={0.6} /><path fillRule="evenodd" clipRule="evenodd" d="M14.02 17.758l6.622 6.622a1.251 1.251 0 11-1.77 1.77l-7.506-7.507a1.251 1.251 0 010-1.77l7.507-7.506a1.251 1.251 0 011.77 1.77l-6.623 6.621z" fill="#fff" /></svg>;
}
export default SvgComponent;